// extracted by mini-css-extract-plugin
export default {"navigate_buttons":"HeaderNavigation_navigate_buttons__eS96c","login":"HeaderNavigation_login__rBVMy","register":"HeaderNavigation_register__AxFX2"};